<template>
  <b-row>
    <b-col cols="12" md="3" class="mb-md-0 mb-2">
      <label>Poste </label>
      <v-select
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :value="branchFilter"
        :options="branchOptions"        
        v-model="branchOptions[0]"
        class="w-100"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:branchFilter', val)"
      />
    </b-col>
    <b-col cols="12" md="3" class="mb-md-0 mb-2">
      <label>Mois</label>
      <v-select
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :value="monthFilter"
        :options="monthOptions"
        v-model="currentMonth"
        class="w-100"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:monthFilter', val)"
      />
    </b-col>    

    <b-col cols="12" md="2" class="mb-md-0 mb-2">
      <label>Type vehicule</label>
      <v-select
        :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
        :value="typeFilter"
        :options="typeOptions"
        class="w-100"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:typeFilter', val)"
      />
    </b-col>

    <b-col cols="12" md="2" class="mb-md-0 mb-2">
      <label>Date Début</label>
      <flat-pickr
        :value="dateFilter"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:dateFilter', val)"
        v-model="currentDate"
        :config="{ altFormat: 'd-m-Y', altInput: true, dateFormat: 'Y-m-d' }"
        class="form-control"
        name="dateFilter"
        id="date"
        placeholder="Date Début"
      />
    </b-col>
    
    <b-col cols="12" md="2" class="mb-md-0 mb-2">
      <label>Date Finale</label>
      <flat-pickr
        :value="dateFinaleFilter"
        :reduce="(val) => val.value"
        @input="(val) => $emit('update:dateFinaleFilter', val)"
        v-model="currentDateFinale"
        :config="{ altFormat: 'd-m-Y', altInput: true, dateFormat: 'Y-m-d' }"
        class="form-control"
        name="dateFinaleFilter"
        id="dateFinale"
        placeholder="Date Finale"
      />
    </b-col>
  </b-row>
</template>

<script>
import { BCard, BCardHeader, BCardBody, BRow, BCol } from "bootstrap-vue";
import vSelect from "vue-select";
import flatPickr from 'vue-flatpickr-component'

export default {
  components: {
    BRow,
    BCol,
    BCard,
    BCardHeader,
    BCardBody,
    vSelect,
    flatPickr,
  },
  props: {
    branchFilter: {
      type: [Number, 0],
      default: 0,
    },
    branchOptions: {
      type: Array,
      required: true,
    },

    monthFilter: {
      type: [String, ""],
      default: "",
    },
    monthOptions: {
      type: Array,
      required: true,
    },
    dateFilter: {
      type: [String, null],
      default: null,
    },
    dateFinaleFilter: {
      type: [String, null],
      default: null,
    },
    dateOptions: {
      type: Array,
      required: true,
    },

    typeFilter: {
      type: [Number, 0],
      default: 0,
    },
    typeOptions: {
      type: Array,
      required: true,
    },

  },
  data() {
    return {
      currentMonth: this.monthOptions[this.getMonth()],
      currentDate: this.getDate(),
      currentDateFinale: this.getDate(),
    };
  },
  methods: {
    getMonth() {
      const current = new Date();
      return current.getMonth()+1;
    },
    getDate() {
      const current = new Date();
      return `${current.getFullYear()}/${current.getMonth()+1}/${current.getDate()}`;
    }
  }
};
</script>


<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
